import React, { FC } from "react";

import {
  useApisMembersAnalysisEmployeeConditionSubmissionsCountCalendarsIndex,
  usePrevNextSelectMonth,
} from "~/hooks";

import { ActivityOriginalCalendar } from "~/ui";

type PropsType = {
  className?: string;
};

export const EmployeeConditionSubmissionsCountCalendar: FC<PropsType> = ({
  className = "",
}: PropsType) => {
  const {
    targetDate,
    targetDateString,
    handlePrevMonthClick,
    handleNextMonthClick,
  } = usePrevNextSelectMonth();

  const { data, isLoading } =
    useApisMembersAnalysisEmployeeConditionSubmissionsCountCalendarsIndex({
      params: {
        targetDate: targetDateString,
      },
    });

  return (
    <ActivityOriginalCalendar
      isLoading={isLoading}
      dailyActivity={data?.employeeConditionSubmissionsCalendar}
      targetDate={targetDate}
      onPrevMonthClick={handlePrevMonthClick}
      onNextMonthClick={handleNextMonthClick}
      isForRate={false}
      className={className}
    />
  );
};
